import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfProcessStepsIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * Component used to display process steps icon
 * @param props - CcfProcessStepsIconProps
 * @returns
 * @example
 */
export function CcfProcessStepsIcon(props: CcfProcessStepsIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g clip-path="url(#clip0_2157_44412)">
        <path
          d="M16 4.8V0C13.68 0 11.92 0 9.6 0V1.6H6.4V14.4C8.08 14.4 7.92 14.4 9.6 14.4V16C18.16 16 7.44 16 16 16V11.2C13.68 11.2 11.92 11.2 9.6 11.2V12.8H8V8.8H9.6V10.4C11.92 10.4 13.68 10.4 16 10.4V5.6C7.6 5.6 18.08 5.6 9.6 5.6V7.2H8V3.2H9.6V4.8C18.16 4.8 7.44 4.8 16 4.8ZM11.2 1.6H14.4V3.2H11.2V1.6ZM11.2 12.8H14.4V14.4H11.2V12.8ZM11.2 7.2H14.4V8.8H11.2V7.2Z"
          fill={props?.fillColor ? props?.fillColor : '#3F5C69'}
        />
        <path
          d="M4.24 7.44L1.36 4.64C1.04 4.32 0.56 4.32 0.24 4.64C-0.08 4.96 -0.08 5.44 0.24 5.76L1.92 7.44C2.24 7.76 2.24 8.24 1.92 8.56L0.24 10.24C-0.08 10.56 -0.08 11.04 0.24 11.36C0.56 11.68 1.04 11.68 1.36 11.36L4.16 8.56C4.48 8.24 4.48 7.76 4.24 7.44Z"
          fill={props?.fillColor ? props?.fillColor : '#3F5C69'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2157_44412">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfProcessStepsIcon;
